import { createDynamicThunk } from ".";

export const fetchSettingsThunk = createDynamicThunk({
  typePrefix: "settings/fetchSettingsThunk",
  endpoint: "/settings/findAll",
  method: "POST",
});

/**
 * Save theme option
 */
export const saveThemeOptionThunk = createDynamicThunk({
  typePrefix: "settings/saveThemeOptionThunk",
  endpoint: "/settings",
  method: "POST",
});

/**
 * Import Data
 */
export const importDataThunk = createDynamicThunk({
  typePrefix: "data/importDataThunk",
  endpoint: "/data/import",
  method: "POST",
});
